import { render, staticRenderFns } from "./externalHomepage.vue?vue&type=template&id=8c97d52a&scoped=true&"
import script from "./externalHomepage.vue?vue&type=script&lang=js&"
export * from "./externalHomepage.vue?vue&type=script&lang=js&"
import style0 from "./externalHomepage.vue?vue&type=style&index=0&id=8c97d52a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c97d52a",
  null
  
)

export default component.exports